<template>
  <v-container fluid class="worker-role-form mt-3 mx-1 centered-tabs">
    <v-row>
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          {{ $t('book/admin:qrcode.import.title') }}
        </h2>

        <v-card
            elevation="0"
            flat
            tile
        >
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" md="6">
                <v-form ref="createForm">

                  <h4 class="primary--text font-weight-medium">
                    {{ $t('book/admin:qrcode.import.create.title') }}
                  </h4>

                  <v-text-field
                      outlined
                      v-model="qrCode.name"
                      clearable
                      :label="$t('common:name')"
                      :rules="[ruleRequired($t('utils:rules.required'))]"
                      tabindex="1"
                  />

                  <v-text-field
                      outlined
                      v-model="qrCode.count"
                      clearable
                      :label="$t('book/admin:qrcode.import.create.count')"
                      :rules="[ruleNotNegative($t('utils:rules.negative-value')), ruleRequired($t('utils:rules.required'))]"
                      type="number"
                      tabindex="2"
                  />

                  <v-text-field
                      outlined
                      v-model="qrCode.start"
                      clearable
                      :label="$t('book/admin:qrcode.import.create.start')"
                      :rules="[ruleNotNegative($t('utils:rules.negative-value'))]"
                      type="number"
                      tabindex="3"
                  />

                  <CustomerTypeahead
                      ref="managerTypeahead"
                      :value="customer"
                      @input="customer = $event"
                      :label="$t('common:customer')"
                      tabindex="4"
                  />

                  <v-btn
                      color="primary"
                      class="mr-3 mb-3 mb-md-0 white--text"
                      rounded
                      elevation="0"
                      @click="createQRCodes()"
                  >{{ $t('buttons:create') }}
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card
            elevation="0"
            flat
            tile
        >
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" md="6">
                <v-form ref="importForm">

                  <h4 class="primary--text font-weight-medium">
                    {{ $t('book/admin:qrcode.import.import-csv.title') }}
                  </h4>

                  <v-file-input
                      accept="text/csv"
                      :label="$t('book/admin:qrcode.import.import-csv.file')"
                      show-size
                      v-model="file"
                      :rules="[ruleRequired($t('utils:rules.requiredFile'))]"
                  />

                  <v-btn
                      color="primary"
                      class="mr-3 mb-3 mb-md-0 white--text"
                      rounded
                      elevation="0"
                      @click="importCodesFromCSV()"
                  >{{ $t('buttons:import') }}
                  </v-btn>

                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card
            elevation="0"
            flat
            tile
        >
          <v-card-text class="pa-5 pb-4">                    
            <DirtyConfirmButtonDialog
                ref="dirtyDialog"
                :btn-text="$t('buttons:back')"
                color="grey"
                :dialog-title="$t('dialog:dirty-save-btn-title')"
                :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                :button1-text="$t('dialog:dirty-save-btn-1-text')"
                :button2-text="$t('dialog:dirty-save-btn-2-text')"
                @clickedButton="$router.go(-1)"
                :dataToWatch="qrCode"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ruleRequired, ruleNotNegative} from "@/modules/core/services/rules";
import QRCodeService from "@/modules/book/services/qrcode-service";
import Utils from "@/modules/core/services/utils";
import CustomerTypeahead from "@/modules/core/components/CustomerTypeAhead";
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";

export default {
  name:"QRCodeImport",
  components: {
    CustomerTypeahead,
    DirtyConfirmButtonDialog
  },
  data() {
    return {
      qrCode: {
        name: null,
        count: 0,
        start: 0,
      },
      customer: null,
      file: null
      
    }
  },  
  mounted() {
    this.$refs.dirtyDialog.startWatch();
  },
  methods: {
    ruleRequired,
    ruleNotNegative,
    createQRCodes() {
      if (!this.$refs.createForm.validate()) {
        // TODO scroll to specific form field which doesnt require the rules
        window.scrollTo(0, 0);
        return;
      }

      QRCodeService.createQRCodes(this.qrCode.name, this.qrCode.count, this.customer, this.qrCode.start,
        () => {
          Utils.showSuccessSnackbar(this.$t('book/admin:qrcode.import.snackbar.success'));
          this.$router.go(-1);
        },
        () => {
          Utils.showFailureSnackbar(this.$t('book/admin:qrcode.import.snackbar.failure'));
        }
      )
    },
    importCodesFromCSV() {
      if (!this.$refs.importForm.validate()) {
        // TODO scroll to specific form field which doesnt require the rules
        window.scrollTo(0, 0);
        return;
      }

      QRCodeService.importCsv(this.file,
        () => {
          Utils.showSuccessSnackbar(this.$t('book/admin:qrcode.import.snackbar.success'));
          this.$router.go(-1);
        },
        () => {
          Utils.showFailureSnackbar(this.$t('book/admin:qrcode.import.snackbar.failure'));
        }
      )
    }
  }
}

</script>
